import React from 'react';

import MoreOptionsCell from '../../Cards/MoreOptionsCell';

// import ViewReportIcon from '../../Icons/ViewReportIcon';
// import { TableContext } from '../TableContext';

interface ViewDetailsProps {
  data?: any;
  sliderCompFn?: (...args: any) => React.ReactNode;
  action?: (...args: any) => void;
  label?: string;
  width?: string;
  icon?: React.ReactNode;
  color?: string;
}

const ViewDetails: React.FC<ViewDetailsProps> = ({
  data,
  sliderCompFn,
  label,
  width,
  icon,
  color,
  action,
}) => {
  // const tableContext = useContext(TableContext);

  // const handleClick = () => {
  //   tableContext?.setShowTableSlider(true);
  //   tableContext?.setSliderComp(sliderCompFn && sliderCompFn(data));
  // };

  return (
    <MoreOptionsCell
      icon={icon || <span>sample icon</span>}
      label={label ?? ''}
      onClick={() => action && action({ data })}
      width={width}
      color={color}
    />
  );
};

export default ViewDetails;
